import { render } from "./2017.vue?vue&type=template&id=3a08c4e9"
import script from "./2017.vue?vue&type=script&lang=js"
export * from "./2017.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__